import "../../../styles/kjedeweb/multiChainProductListItem.scss";

import Icon, { iconTypes } from "../../common/components/Icon.jsx";

import CheckBox from "../../common/components/CheckBox";
import DefaultLogo from "../../../assets/images/logoImages/DefaultLogo.png";
import FuturePriceItem from "./FuturePriceComponent";
import { Localization } from "../../common/util/localization.jsx";
import LogoChain1 from "../../../assets/images/logoImages/LogoChain1.png";
import LogoChain22 from "../../../assets/images/logoImages/LogoChain22.png";
import LogoChain24 from "../../../assets/images/logoImages/LogoChain24.png";
import LogoChain26 from "../../../assets/images/logoImages/LogoChain26.png";
import LogoChain30 from "../../../assets/images/logoImages/LogoChain30.png";
import LogoChain31 from "../../../assets/images/logoImages/LogoChain31.png";
import LogoChain34 from "../../../assets/images/logoImages/LogoChain34.png";
import LogoChain37 from "../../../assets/images/logoImages/LogoChain37.png";
import LogoChain38 from "../../../assets/images/logoImages/LogoChain38.png";
import LogoChain40 from "../../../assets/images/logoImages/LogoChain40.png";
import LogoChain43 from "../../../assets/images/logoImages/LogoChain43.png";
import LogoChain47 from "../../../assets/images/logoImages/LogoChain47.png";
import LogoChain5 from "../../../assets/images/logoImages/LogoChain5.png";
import MultiChainProductModal from "./MultiChainProductModal.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../common/components/ResponsiveRows";
import SingleChainProductModal from "./SingleChainProductModal.jsx";

import moment from "moment";
import { toLocaleFixed } from "../../common/util/localization.jsx";

const LOGOS = {
    "defaultlogo.png": DefaultLogo,
    "logochain22.png": LogoChain22,
    "logochain26.png": LogoChain26,
    "logochain31.png": LogoChain31,
    "logochain40.png": LogoChain40,
    "logochain47.png": LogoChain47,
    "logochain1.png": LogoChain1,
    "logochain24.png": LogoChain24,
    "logochain30.png": LogoChain30,
    "logochain34.png": LogoChain34,
    "logochain43.png": LogoChain43,
    "logochain5.png": LogoChain5,
    "logochain37.png": LogoChain37,
    "logochain38.png": LogoChain38
};

/**
 * Returns a render node, for selecting a single product
 * @param {object} props 
 * @returns {node}
 */
function SelectProduct({product, selected, editSelectedProduct}) {
    const getId = () => `${product.productId}:${product.chainId}`;
    /**
     * Calls the action to select/unselect the product
     * @param {object} change 
     * @returns {*}
     */
    function onClickSelect(change) {
        editSelectedProduct({
            [getId()]: change[getId()] ? product : undefined,
        });
    }
    /**
     * Returns true if the product
     * @param {object} change 
     * @returns {boolean}
     */

    return (
        <div className="checkbox-column">
            <CheckBox property={getId()} source={selected} label="" onChange={onClickSelect} />
        </div>
    );
}
SelectProduct.propTypes = {
    product: PropTypes.object.isRequired,
    selected: PropTypes.object.isRequired,
    editSelectedProduct: PropTypes.func.isRequired,
};

/**
 * Fetch the url to a logo given its image name
 * @param {string} name 
 * @returns {string}
 */
export function getChainLogo(name) {
    if (name && LOGOS[name.toLowerCase()]) {
        const logo = LOGOS[name.toLowerCase()];
        return logo;
    } else {
        return DefaultLogo;
    }
}

export class MultiChainSortimentListHeader extends React.PureComponent {
    render() {
        const {
            localization,
            multiSelect,
            showInvoiceGroup,
        } = this.props;

        return (
            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                <ResponsiveRows gutters={false}>
                    <ResponsiveColumn lg={2.5}>
                        <div className="product-view-list-header">
                            {localization.text("chain", "chainSortiment", "productAndStatus")}
                        </div>
                    </ResponsiveColumn>
                    <ResponsiveColumn lg={8.5}>
                        {multiSelect && (<div style={{width:"42px",height:"10px",float:"left"}} />)}
                        <ResponsiveRows gutters={false} columns={10}>
                            <ResponsiveColumn lg={1}></ResponsiveColumn>
                           
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header" style ={{textAlign: "center"}}>
                                    {localization.text("chain", "chainSortiment", "productStatus")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header">
                                    {localization.text("chain", "chainSortiment", "noOfSalesUnits")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header">
                                    {localization.text("chain", "chainSortiment", "netPrice")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header">
                                    {localization.text("chain", "chainSortiment", "netPricePerUnit")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header">
                                    {localization.text("chain", "chainSortiment", "adminChargePercent")}
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn lg={1}>
                                <div className="product-view-list-header">
                                    {localization.text("chain", "chainSortiment", "changed")}
                                </div>
                            </ResponsiveColumn>
                            {showInvoiceGroup && (
                                <ResponsiveColumn lg={1}>
                                    <div className="product-view-list-header">
                                        {localization.text("chain", "chainSortiment", "invoiceGroup")}
                                    </div>
                                </ResponsiveColumn>
                            )}
                        </ResponsiveRows>
                    </ResponsiveColumn>
                    <ResponsiveColumn lg={1}></ResponsiveColumn>
                </ResponsiveRows>
            </div>
        );
    }
}

MultiChainSortimentListHeader.propTypes = {
    localization: Localization.propTypes.isRequired,
    multiSelect: PropTypes.bool.isRequired,
    showInvoiceGroup : PropTypes.bool,
};

export class MultiChainSortimentListItem extends React.PureComponent {
    constructor(props) {
        super(props);

        this.showProductModal = this.showProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);

        this.state = {
            mouseOver: false
        };
    }

    onMouseOver() {
        this.setState({
            mouseOver: true
        });
    }

    onMouseOut() {
        this.setState({
            mouseOver: false
        });
    }

    showProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        const {
            localization,
            productGroup,
            selectedTabChainId,
        } = this.props;

        const title = localization.text("chain", "productDetail");
        const saveButtonText = localization.text("chain", "save");

        if(selectedTabChainId === "all"){
            this.props.setModal(<MultiChainProductModal localization={localization} product={productGroup[0]} onCloseModal={this.closeProductModal} width={1600} title={title} saveButtonText={saveButtonText} />);
        }
        else {
            this.props.setModal(<SingleChainProductModal localization={localization} product={productGroup[0]} onCloseModal={this.closeProductModal} width={1600} title={title} saveButtonText={saveButtonText} />);
        }

    }

    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        this.props.setModal(null);
        this.props.clearChainProductDetails();
    }

    capitalizeFirstLetter(s) {
        if (!s) {
            return "";
        }
        s = s.toLowerCase();
        return s.charAt(0).toUpperCase() + s.slice(1);
    }

    render() {
        const {
            chains,
            productGroup,
            multiSelect,
            selected,
            editSelectedProduct,
        } = this.props;

        return (
            <div className={`product-view-list-item-wrapper not-interactable${this.state.mouseOver ? " mouse-over" : ""}`} draggable={false} onMouseEnter={this.onMouseOver} onMouseLeave={this.onMouseOut}>
                <ResponsiveRows gutters={false}>
                    <ResponsiveColumn xs={2.5}>
                        <div className={"product-view-list-item product-description"}>
                            <div className={"product-view-list-item-image-background"} onClick={this.showProductModal}>
                                {productGroup[0].imageUrl && (
                                    <React.Fragment>
                                        <img src={productGroup[0].imageUrl} className={"product-view-list-item-image"} />
                                    </React.Fragment>
                                )}
                            </div>
                            <div className="label16 product-view-list-item-prd-info_multiline" onClick={this.showProductModal}>
                                <div>EPD {productGroup[0].epdNo}</div>
                                <div>{productGroup[0].productName}</div>
                            </div>
                        </div>
                    </ResponsiveColumn>
                    <ResponsiveColumn xs={8.5} className="product-view-list-item-chain">
                        {productGroup.map((product, idx) => (
                            <div className="container" key={idx}>
                                {multiSelect && (
                                    <SelectProduct product={product} selected={selected} editSelectedProduct={editSelectedProduct}/>
                                )}
                                <ResponsiveRows key={idx} gutters={false} columns={10}>
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <div className="product-view-list-item-chain-status">
                                            <img className={"product-view-list-item-logo"} src={getChainLogo(chains && chains[product.chainId] && chains[product.chainId].chainLogoFileName)}/>
                                            <div>
                                                <div className="product-view-list-item-prd-info_catalogueInfo" >
                                                    {product.inCatalogue ? <div className="circle-green"/> : <div className="circle-red"/>}{product.inCatalogue ? "Åpen" : "Stengt"}
                                                </div>
                                                {/*<div className="product-view-list-item-prd-info_catalogueInfo" >
                                                    {product.inCatalogue && (<div className="circle-blue"/>)}
                                                    {product.inCatalogue ? "I varekatalog" : "Ikke i varekatalog"}
                                                </div>*/}
                                            </div>
                                        </div>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <div className="label14 product-view-list-item"  style={{ textAlign: "center" }}>
                                            <div style={{ width: "100%" }}>
                                                {product.status}
                                            </div>
                                        </div>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <div className="label14 product-view-list-item-price">
                                            <div style={{ width: "100%" }}>
                                                {product.noOfSalesUnits}
                                            </div>
                                        </div>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <div className="label14 product-view-list-item-price" >
                                            <div >
                                                {product.currentNetPrice && toLocaleFixed(product.currentNetPrice,2)}
                                            </div>
                                        </div>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <div className="label14 product-view-list-item-price">
                                            <div>
                                                {product.currentNetPricePerSalesUnit && toLocaleFixed(product.currentNetPricePerSalesUnit,3)}
                                            </div>
                                        </div>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <FuturePriceItem
                                            currentValue={product.adminChargePercent}
                                            futureEndValue={product.futureAdminCharge}
                                            futureEndValueDate={product.futureAdminChargeDate}
                                        />
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={1} lg={1}>
                                        <div className="label14 product-view-list-item">
                                            <div style={{ width: "100%" }}>
                                                {product.lastChangedDate && moment(product.lastChangedDate).format("DD.MM.YY")}
                                            </div>
                                        </div>
                                    </ResponsiveColumn>
                                    {product.showInvoiceGroup && (
                                        <ResponsiveColumn xs={1} lg={1}>
                                            <div className="label14 product-view-list-item">
                                                <div style={{ width: "100%" }}>
                                                    {this.capitalizeFirstLetter(product.invoiceGroupName)}
                                                </div>
                                            </div>
                                        </ResponsiveColumn>
                                    )}
                                </ResponsiveRows>
                            </div>
                        ))}
                    </ResponsiveColumn>
                    <ResponsiveColumn xs={1} className="product-view-list-item-chain">
                        {this.state.mouseOver && (
                            <button className="btn circular" onClick={this.showProductModal}>
                                <Icon type={iconTypes.pen} />
                            </button>
                        )}
                    </ResponsiveColumn>
                </ResponsiveRows>
            </div>
        );
    }
}

MultiChainSortimentListItem.propTypes = {
    chains: PropTypes.object.isRequired,
    clearChainProductDetails: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    productGroup: PropTypes.arrayOf(PropTypes.object),
    setModal: PropTypes.func.isRequired,
    selected: PropTypes.object.isRequired,
    editSelectedProduct: PropTypes.func.isRequired,
    multiSelect: PropTypes.bool.isRequired,
    selectedTabChainId : PropTypes.string,
};

MultiChainSortimentListItem.defaultProps = {
};